import React from 'react';

export function TabSkeleton() {
  return (
    <div className="space-y-4 animate-pulse">
      {/* Header skeleton */}
      <div className="flex items-center space-x-2 mb-4">
        <div className="w-5 h-5 bg-muted rounded" />
        <div className="h-6 w-48 bg-muted rounded" />
      </div>
      
      {/* Content skeleton */}
      <div className="space-y-6">
        {/* Form fields skeleton */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          {[1, 2, 3, 4].map(i => (
            <div key={i} className="space-y-2">
              <div className="h-4 w-24 bg-muted rounded" />
              <div className="h-10 bg-muted rounded" />
            </div>
          ))}
        </div>
        
        {/* Additional content blocks */}
        <div className="space-y-4">
          <div className="h-32 bg-muted rounded" />
          <div className="h-24 bg-muted rounded" />
        </div>
      </div>
    </div>
  );
}